import { api } from "../../services/Api.js";

export function get_teacher_talks({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    // retrun chainable promise
    return api
    .post(school,"get_teacher_talks.php",payload)
    .then( result =>{ 
      commit('SET_TEACHER_TALKS', {store_key:payload.store_key,talks:result.data});
      return result;
    })
    .catch( error => {
      //console.log("ERROR GETTING CALENDAR",error);
      return error;
    })

}